import React from "react";
import { FaUsers, FaEye, FaCheck, FaBan, FaEyeSlash, FaUndo } from "react-icons/fa";
import StatusBadge from '../../../../components/StatusBadge';
import '../css/SystemUsers.css';

const SystemUsersTable = ({
  loading,
  activeTable,
  organisers,
  generalUsers,
  onViewOrganiser,
  onViewCustomer,
  onToggleStatus,
  onToggleEventDisabled,
  currentPage,
  itemsPerPage,
}) => {
  if (loading) {
    return (
      <div className="system-users-loading">
        <div className="system-users-loading__spinner" />
        <p className="system-users-loading__text">Loading users...</p>
      </div>
    );
  }

  if (activeTable === "Organiser") {
    return (
      <div className="system-users-card">
        <div className="system-users-card__header">
          <h3 className="system-users-card__title">
            <FaUsers /> Events
          </h3>
        </div>
        <div className="system-users-card__body">
          <div className="system-users-table-wrapper">
            <table className="system-users-table">
              <thead>
                <tr>
                  <th>Event</th>
                  <th>Date of Event</th>
                  <th>Organiser Name</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(organisers) && organisers.length > 0 ? (
                  organisers
                    .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                    .map((organiser, index) => (
                    <tr key={`organiser-${organiser.user_id}-${index}`}>
                      <td>{organiser.event_name}</td>
                      <td>
                        {organiser.formatted_date ||
                          new Date(organiser.startdate).toLocaleDateString()}
                      </td>
                      <td>{`${organiser.firstname} ${organiser.surname}`}</td>
                      <td>
                        <StatusBadge 
                          status={organiser.event_status === true || organiser.event_status === 'Approved' ? 'Approved' : 
                                   organiser.event_status === false || organiser.event_status === 'Rejected' ? 'Rejected' : 'Pending'}
                          variant="system-users"
                        />
                      </td>
                      <td>
                        <div className="system-users-actions">
                          <button
                            type="button"
                            className="system-users-action-btn system-users-action-btn--view"
                            onClick={() => onViewOrganiser(organiser.user_id)}
                            title="View organizer details"
                          >
                            <FaEye />
                          </button>
                          <button
                            type="button"
                            className={`system-users-action-btn ${
                              organiser.disabled
                                ? "system-users-action-btn--toggle-enabled"
                                : "system-users-action-btn--toggle-disabled"
                            }`}
                            onClick={() =>
                              onToggleEventDisabled(organiser.event_id, organiser.disabled)
                            }
                            title={
                              organiser.disabled
                                ? "Add back to events"
                                : "Remove from events"
                            }
                          >
                            {organiser.disabled ? <FaUndo /> : <FaEyeSlash />}
                            <span className="system-users-action-label">
                              {organiser.disabled ? "Add back to events" : "Remove from events"}
                            </span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr key="no-organisers">
                    <td colSpan="4" className="system-users-no-data">
                      No organizers found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  if (activeTable === "General Users") {
    return (
      <div className="system-users-card">
        <div className="system-users-card__header">
          <h3 className="system-users-card__title">
            <FaUsers /> General Users
          </h3>
        </div>
        <div className="system-users-card__body">
          <div className="system-users-table-wrapper">
            <table className="system-users-table">
              <thead>
                <tr>
                  <th>Customer Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(generalUsers) && generalUsers.length > 0 ? (
                  generalUsers
                    .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                    .map((user, index) => (
                    <tr key={`user-${user.user_id}-${index}`}>
                      <td>{`${user.firstname} ${user.surname}`}</td>
                      <td>{user.email}</td>
                      <td>
                        <StatusBadge 
                          status={user.role}
                          variant="system-users"
                        />
                      </td>
                      <td>
                        <StatusBadge 
                          status={user.is_disabled === 1 ? 'Disabled' : 'Enabled'}
                          variant="system-users"
                        />
                      </td>
                      <td>
                        <div className="system-users-actions">
                          <button
                            type="button"
                            className="system-users-action-btn system-users-action-btn--view"
                            onClick={() => onViewCustomer(user.user_id)}
                            title="View user details"
                          >
                            <FaEye />
                          </button>
                          <button
                            type="button"
                            className={`system-users-action-btn ${
                              user.is_disabled === 1
                                ? "system-users-action-btn--toggle-enabled"
                                : "system-users-action-btn--toggle-disabled"
                            }`}
                            onClick={() =>
                              onToggleStatus(user.user_id, user.is_disabled)
                            }
                            title={
                              user.is_disabled === 1 ? "Enable user" : "Disable user"
                            }
                          >
                            {user.is_disabled === 1 ? <FaCheck /> : <FaBan />}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr key="no-users">
                    <td colSpan="5" className="system-users-no-data">
                      No general users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default SystemUsersTable;
